import { render, staticRenderFns } from "./reply_button.vue?vue&type=template&id=f5a48c60&"
import script from "./reply_button.vue?vue&type=script&lang=js&"
export * from "./reply_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports